import React, { useState, useEffect } from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			width: '75%',
			maxWidth: 1000
		},
		position: 'relative'
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20,
		overflowY: 'scroll'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	},
	area: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		marginBottom: 15
	},
	areaTitle: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 10,
		width: '100%',
		'& i': {
			marginRight: 15,
			color: '#D0CFD2'
		},
		'& .selected': {
			color: '#6B4AD6'
		},
		'& h4': {
			margin: 0
		}
	},
	areaMain: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		paddingLeft: '10%'
	},
	kennel: {
		padding: 5,
		marginRight: 15,
		marginBottom: 10,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		'& i': {
			marginRight: 15,
			color: '#D0CFD2',
			cursor: 'pointer'
		},
		'& .selected': {
			color: '#6B4AD6'
		}
	},
	kennelName: {
		'& h5': {
			margin: 0
		}
	},
	selectedKennels: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		height: 50,
		'& i': {
			color: '#6B4AD6',
			fontSize: 18,
			marginRight: 15,
			cursor: 'pointer'
		},
		'& h4': {
			margin: 0,
			fontSize: 16,
			fontFamily: 'Nunito',
			color: '#1A1A35',
			fontWeight: '600'
		}
	}
}))

const KennelBlockDialog = (props) => {
	const classes = useStyles()

	const { isShown, setIsShown, facility, assignKennels, selectedPlaygroup } = props

	useEffect(() => {
		if (selectedPlaygroup) {
			let ourKens = facility.kennels.filter((k) => selectedPlaygroup.kennels.includes(k.reference_number))
			selectKennel(ourKens.map((k) => k.reference_number))
		}
	}, [facility, selectedPlaygroup])

	const [selectedKennels, selectKennel] = useState([])

	const getClass = (kennel) => {
		if (selectedKennels.includes(kennel.reference_number)) return 'fas fa-check-square selected'
		return 'far fa-square'
	}

	const setKennels = (kennel) => {
		let kens
		if (selectedKennels.includes(kennel.reference_number)) {
			kens = selectedKennels.filter((k) => k !== kennel.reference_number)
		} else {
			kens = [...selectedKennels, kennel.reference_number]
		}
		selectKennel(kens)
	}

	const getTopClass = (area) => {
		let areaKennels = facility.kennels.filter((k) => k.area_id === area._id)
		if (!areaKennels.length) return 'far fa-square'
		let allSelected = areaKennels.every((k) => selectedKennels.includes(k.reference_number))
		if (allSelected) return 'fas fa-check-square selected'
		return 'far fa-square'
	}

	const selectAllKennels = (area) => {
		let areaKennels = facility.kennels.filter((k) => k.area_id === area._id)
		let mappedAreaKennels = areaKennels.map((k) => k.reference_number)

		let kens = [...selectedKennels]
		let allSelected = areaKennels.every((k) => selectedKennels.includes(k.reference_number))
		if (allSelected) {
			kens = kens.filter((k) => {
				return !areaKennels.find((ken) => ken.reference_number === k)
			})
		} else {
			areaKennels.forEach((ken, i) => {
				if (!kens.includes(ken.reference_number)) kens.push(ken.reference_number)
			})
		}

		selectKennel(kens)
	}

	return !selectedPlaygroup ? null : (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => {
				setIsShown(false)
			}}>
			<DialogTitle>KENNEL ASSIGNMENTS: {selectedPlaygroup.name}</DialogTitle>
			<DialogContent>
				<span
					className={classes.close}
					onClick={() => {
						setIsShown(false)
					}}>
					X
				</span>

				<div className={classes.formWrapper}>
					{selectedKennels.length ? (
						<div className={classes.selectedKennels}>
							<i className="fa fa-minus-square checked" onClick={() => selectKennel([])} />
							<h4>
								{selectedKennels.length} Kennel
								{selectedKennels.length > 1 ? 's' : ''} Selected
							</h4>
						</div>
					) : null}
					{facility.areas.map((area) => {
						return (
							<div className={classes.area}>
								<div className={classes.areaTitle}>
									<i className={getTopClass(area)} onClick={() => selectAllKennels(area)} />
									<h4>{area.name}</h4>
								</div>

								<div className={classes.areaMain}>
									{facility.kennels
										.filter((k) => k.area_id === area._id)
										.map((kennel) => {
											return (
												<div className={classes.kennel}>
													<i
														className={getClass(kennel)}
														onClick={() => setKennels(kennel)}
													/>
													<div className={classes.kennelName}>
														<h5>{kennel.reference_number}</h5>
														<span>{kennel.type}</span>
													</div>
												</div>
											)
										})}
								</div>
							</div>
						)
					})}
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				{/* <Button
          variant="contained"
          onClick={ createAddOn }
          color="secondary"
        >
          Apply
        </Button> */}
				<Button variant="contained" onClick={() => assignKennels(selectedKennels)} color="secondary">
					SAVE
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						// selectKennel(
						//   facility.kennels.filter(k => k.playgroup_id === selectedPlaygroup)
						// );
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default KennelBlockDialog
